import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {BringozArray} from "../persistence-layer/bringoz-array";
import {TeamModel} from "./models/team.model";

angular
  .module('bringoz.admin.teams')
  .factory('$teams', TeamsObjectFactory);

export type $teamsFactory = () => BringozArray<TeamModel>;

/* @ngInject */
function TeamsObjectFactory($bringozFactory: $bringozFactory,
                            teamsAPI: BringozApi,
                            Teams_DS: DataStoreConfig) {

  function $teams(id: string) {
    return $bringozFactory(id, teamsAPI, Teams_DS)
  }

  return $teams;
}
